import React from 'react';

import { Stack } from '@mui/material';

import AccommodationBundlesContainer from '~/components/Accommodation/Pages/Bundles/AccommodationBundlesContainer';
import { AccommodationTabs } from '~/components/Accommodation/Pages/Home/AccommodationHomePage';
import MmaoOffersResultsContainer from '~/components/Accommodation/Pages/MmaoOffers/MmaoOffersResultsContainer';
import AccommodationAmenitiesResultsContainer from '~/components/Accommodation/Pages/Properties/components/AccommodationAmenitiesResultsContainer';
import AccommodationFacilitiesResultsContainer from '~/components/Accommodation/Pages/Properties/components/AccommodationFacilitiesResultsContainer';
import AccommodationPropertiesResultsContainer from '~/components/Accommodation/Pages/Properties/components/AccommodationPropertiesResultsContainer';
import AccommodationUnmappedSuppliersResultsContainer from '~/components/Accommodation/Pages/Properties/components/AccommodationPropertiesUnmappedSuppliersResultsContainer';
import PotentialMappingsResultsContainer from '~/components/Accommodation/Pages/Properties/components/PotentialMappingsResultsContainer';
import DynamicConfigurationsPage from '~/components/Accommodation/Pages/Properties/components/DynamicConfiguration/DynamicConfigurationsPage';

interface Props {
  selectedTab: AccommodationTabs;
}

function AccommodationProperties({ selectedTab }: Props) {
  return (
    <Stack direction="column" spacing={2}>
      {selectedTab === AccommodationTabs.PROPERTIES && <AccommodationPropertiesResultsContainer />}
      {selectedTab === AccommodationTabs.UNMAPPED_SUPPLIERS && <AccommodationUnmappedSuppliersResultsContainer />}
      {selectedTab === AccommodationTabs.POTENTIAL_MAPPINGS && <PotentialMappingsResultsContainer />}
      {selectedTab === AccommodationTabs.FACILITIES && <AccommodationFacilitiesResultsContainer />}
      {selectedTab === AccommodationTabs.AMENITIES && <AccommodationAmenitiesResultsContainer />}
      {selectedTab === AccommodationTabs.MMAO_OFFERS && <MmaoOffersResultsContainer />}
      {selectedTab === AccommodationTabs.BUNDLES && <AccommodationBundlesContainer />}
      {selectedTab === AccommodationTabs.DYNAMIC_CONFIGURATIONS && <DynamicConfigurationsPage />}
    </Stack>
  );
}

export default AccommodationProperties;
